<template>
		<div data-component="choice">
			<icon
				v-if="loaded"
				data-element="check-circle"
				size="sm"
				:icon="getIcon"
				:alt="`${getName} checkbox`"
				:iconColor="$store.getters['ui/getSecondaryColor']"
			/>
			<p
				data-element="choice-name"
				v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
				v-modify-leading="{modifyLeading: $store.getters['ui/getBodyCopyFontLeading']}"
			>{{ getName }}</p>
			<p
				data-element="choice-price"
				v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
				v-modify-leading="{modifyLeading: $store.getters['ui/getBodyCopyFontLeading']}"
			>+ £{{ getPrice | fixedPrice }}</p>
		</div>
</template>

<script>

	import Icon from '@/components/ui/Icon';

	export default {
		props: [
			'choice',
			'getProduct',
			'selected',
			'isPortion'
		],
		data () {
			return {
				loaded: null
			}
		},
		components: {
			Icon
		},
		computed: {
			getIcon () {
				return this.selected ? 'checked-circle' : 'unchecked-circle'
			},
			getName () {
				return this.isPortion ?
					this.choice.name :
					this.getProduct(this.choice.productId).displayRecords.length &&
					this.getProduct(this.choice.productId).displayRecords[0].name;
			},
			getPrice () {
				if (this.isPortion) {
					return this.choice.price;
				} else {
					const aztecChoice = this.getProduct(this.choice.productId);
					return (aztecChoice.displayRecords.length &&
									aztecChoice.portions &&
									aztecChoice.portions[0] &&
									aztecChoice.portions[0].price) || 0;
				}
			}
		},
		mounted () {
			// This is a workaround for a bug in vue-simple-svg
			this.loaded = true;
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/assets/scss/variables.scss';
	@import '@/assets/scss/helpers.scss';

	[data-component='choice'] {
		display:flex;
		align-items:center;
		padding:12px 10px;
		margin-bottom:6px;
		margin-top:6px;
		background-color:#fafafa;
		-webkit-tap-highlight-color:transparent;
		[data-element='check-circle'] {
			margin-bottom:2px;
			-webkit-tap-highlight-color:transparent;
		}
		[data-element='choice-name'] {
			font-size:18px;
			font-weight:500;
			line-height:1.33;
			margin-right:8px;
			margin-left:8px;
			flex-grow:1;
			-webkit-tap-highlight-color:transparent;
			-webkit-user-select:none;
			-moz-user-select:none;
			-ms-user-select:none;
			user-select:none;
			@include whenScreenIs(sm) {
				max-width:244px;
			}
		}
		[data-element='choice-price'] {
			font-size:16px;
			font-weight:500;
			min-width:54px;
			-webkit-tap-highlight-color:transparent;
			-webkit-user-select:none;
			-moz-user-select:none;
			-ms-user-select:none;
			user-select:none;
		}
	}

</style>
